"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MdapSdk = exports.CustomPlugin = exports.host = exports.BasePlugin = void 0;
var reporter_1 = require("./reporter");
var api_1 = require("./api");
var log_1 = require("./utils/log");
var storage_1 = require("./utils/storage");
var constants_1 = require("./constants");
var validators_1 = require("./utils/validators");
var manifest_json_1 = __importDefault(require("./manifest.json"));
var basePlugin_1 = require("./plugin/basePlugin");
Object.defineProperty(exports, "BasePlugin", { enumerable: true, get: function () { return __importDefault(basePlugin_1).default; } });
var constants_2 = require("./constants");
Object.defineProperty(exports, "host", { enumerable: true, get: function () { return constants_2.host; } });
var custom_1 = require("./plugin/custom");
Object.defineProperty(exports, "CustomPlugin", { enumerable: true, get: function () { return __importDefault(custom_1).default; } });
var GET_SAMPLED_RESULT_FROM_CLIENT_VALUE = '-1';
var DEFAULT_SAMPLE_VALUE = 0.1;
var CONFIG_DEFAULT_MAX_AGE = 30 * 60000;
var MdapSdk = /** @class */ (function () {
    function MdapSdk(configs) {
        var _a, _b, _c, _d;
        this.inited = false;
        this.enable = false;
        // private pluginList: BasePlugin<unknown>[] = [];
        this.remoteConfigMap = {};
        this.localConfigUnexpired = false;
        this.configMonitor = __assign({}, constants_1.defaultConfigMonitor);
        try {
            this.configs = configs;
            this.network = new api_1.Network({
                env: (_a = configs.environment) !== null && _a !== void 0 ? _a : 'test',
                app_name: configs.app_name,
                secret_key: configs.secret_key,
                report_host: configs.report_host
            });
            this.reporter = new reporter_1.Reporter(configs, this.network);
            log_1.Logger.mute = !configs.logger;
            this.storage = new storage_1.MdapStorage({
                name: constants_1.CONFIT_STORAGE_PREFIX
            });
            this.initConfig();
            var userIdChanged = ((_c = (_b = this.localConfig) === null || _b === void 0 ? void 0 : _b.user_id) !== null && _c !== void 0 ? _c : undefined) !== ((_d = this.configs.user_id) !== null && _d !== void 0 ? _d : undefined);
            var shouldUpdateConfig = !configs.async_config && (!this.localConfigUnexpired || userIdChanged);
            if (shouldUpdateConfig) {
                this.updateLocalConfig();
            }
        }
        catch (error) {
            log_1.Logger.log('Failed to init mdap sdk');
            log_1.Logger.error(error);
        }
    }
    MdapSdk.prototype.setConfig = function (asyncConfigs) {
        var _a, _b, _c, _d;
        if (asyncConfigs === void 0) { asyncConfigs = {}; }
        var userIdChanged = ((_b = (_a = this.localConfig) === null || _a === void 0 ? void 0 : _a.user_id) !== null && _b !== void 0 ? _b : undefined) !== ((_c = asyncConfigs.user_id) !== null && _c !== void 0 ? _c : undefined);
        this.configs = Object.assign(this.configs, asyncConfigs);
        (_d = this.reporter) === null || _d === void 0 ? void 0 : _d.updateConfig(this.configs);
        if (!this.localConfigUnexpired || userIdChanged) {
            this.updateLocalConfig();
        }
        this.sendConfigMonitor(userIdChanged ? 1 : 0);
    };
    Object.defineProperty(MdapSdk.prototype, "localConfigStorageKey", {
        get: function () {
            // 以 application 为划分维度, 按版本检测
            var _a = this.configs, app_version = _a.app_version, app_name = _a.app_name, _b = _a.environment, environment = _b === void 0 ? 'test' : _b;
            return app_name + "_" + environment + "_" + (app_version !== null && app_version !== void 0 ? app_version : 'unknown');
        },
        enumerable: false,
        configurable: true
    });
    MdapSdk.prototype.getLocalConfig = function () {
        var _a, _b, _c, _d, _e;
        /**
         * 优先读取本地配置，获取不到本地配置或配置过期，
         */
        var localConfig = this.storage.getObject(this.localConfigStorageKey);
        if (localConfig === null || localConfig === void 0 ? void 0 : localConfig.config) {
            var remoteConfig = localConfig.config;
            var enable = !(((_a = localConfig.sdk_spec) === null || _a === void 0 ? void 0 : _a.status) === 'DISABLED') && ((remoteConfig === null || remoteConfig === void 0 ? void 0 : remoteConfig.vip_user) || ((_c = (_b = remoteConfig === null || remoteConfig === void 0 ? void 0 : remoteConfig.switch_config_extra) === null || _b === void 0 ? void 0 : _b.switch_config) === null || _c === void 0 ? void 0 : _c.is_sampled));
            var maxAge = ((_d = localConfig.sdk_spec) === null || _d === void 0 ? void 0 : _d.config_max_age) ? ((_e = localConfig.sdk_spec) === null || _e === void 0 ? void 0 : _e.config_max_age) * 1000 : CONFIG_DEFAULT_MAX_AGE;
            // check if should fetch remote config
            var current = new Date().getTime();
            this.localConfigUnexpired = !!(localConfig.last_update
                && (current >= localConfig.last_update &&
                    localConfig.last_update + maxAge > current));
            return {
                enable: !!enable,
                config: localConfig
            };
        }
        // 本地配置不存在
        return {
            enable: false
        };
    };
    MdapSdk.prototype.initPluginConfigs = function () {
        var _a, _b;
        var config = (_a = this.localConfig) === null || _a === void 0 ? void 0 : _a.config;
        if (!((_b = config === null || config === void 0 ? void 0 : config.switch_config) === null || _b === void 0 ? void 0 : _b.switch_config)) {
            return;
        }
        try {
            var _c = config.switch_config.switch_config, app_sample = _c.app_sample, enable_tasks = _c.enable_tasks, pluginConfigs = __rest(_c, ["app_sample", "enable_tasks"]);
            // 更新插件配置
            for (var _i = 0, _d = Object.keys(pluginConfigs); _i < _d.length; _i++) {
                var configKey = _d[_i];
                var remoteConfig = pluginConfigs[configKey];
                var formattedConfig = {};
                // Init remote plugins-config
                if (remoteConfig.filter_type === 'regexp') {
                    formattedConfig.path = remoteConfig.filter_value.map(function (val) { return new RegExp(val); });
                }
                if (remoteConfig.filter_type === 'string') {
                    formattedConfig.path = remoteConfig.filter_value;
                }
                this.remoteConfigMap[configKey] = formattedConfig;
            }
            this.configMonitor.enable_tasks = enable_tasks !== null && enable_tasks !== void 0 ? enable_tasks : 0;
        }
        catch (error) {
            log_1.Logger.log('Failed to init remote configs');
        }
    };
    MdapSdk.prototype.initConfig = function () {
        var _this = this;
        var _a, _b;
        try {
            // Get local configs
            var localConfig = this.getLocalConfig();
            this.enable = localConfig.enable;
            this.localConfig = localConfig.config;
            if (this.enable) {
                // Update plugin configs
                this.initPluginConfigs();
                // Start checking and reporting
                (_a = this.reporter) === null || _a === void 0 ? void 0 : _a.start();
                // Set encryption config
                if (this.localConfig) {
                    this.network.setEncryptionConfig(this.localConfig);
                }
                if (!this.configs.async_config) {
                    // execute after registering plugins(synchrously)
                    setTimeout(function () {
                        _this.sendConfigMonitor();
                    }, 0);
                }
                if (((_b = this.localConfig) === null || _b === void 0 ? void 0 : _b.time_offset) && this.reporter) {
                    this.reporter.timeOffset = this.localConfig.time_offset;
                }
            }
            else {
                log_1.Logger.warn("[MDAP] Application " + this.configs.app_name + " is out of sampling. SDK will not collect and report data.");
            }
            this.inited = true;
        }
        catch (error) {
            // console.trace(error);
            log_1.Logger.log('Failed to init config');
        }
    };
    Object.defineProperty(MdapSdk.prototype, "defaultSample", {
        get: function () {
            var hasValidSampleConfig = typeof this.configs.sample === 'number' && this.configs.sample >= 0 && this.configs.sample <= 1;
            if (hasValidSampleConfig) {
                return this.configs.sample;
            }
            return DEFAULT_SAMPLE_VALUE;
        },
        enumerable: false,
        configurable: true
    });
    // 重置本地配置
    MdapSdk.prototype.resetLocalConfig = function () {
        try {
            this.storage.removeItem(this.localConfigStorageKey);
        }
        catch (error) {
            //
        }
    };
    // 初始化后执行回调
    MdapSdk.prototype.updateLocalConfig = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        return __awaiter(this, void 0, void 0, function () {
            var localConfig, localConfigCheckSum, localSampledConfig, shouldReCalcSample, configs, useLocalConfig, error_1;
            return __generator(this, function (_q) {
                switch (_q.label) {
                    case 0:
                        localConfig = this.localConfig;
                        _q.label = 1;
                    case 1:
                        _q.trys.push([1, 5, , 6]);
                        if (!!((_a = this.reporter) === null || _a === void 0 ? void 0 : _a.fingerprint)) return [3 /*break*/, 3];
                        return [4 /*yield*/, ((_b = this.reporter) === null || _b === void 0 ? void 0 : _b.initFingerprint())];
                    case 2:
                        _q.sent();
                        _q.label = 3;
                    case 3:
                        localConfigCheckSum = (_d = (_c = localConfig === null || localConfig === void 0 ? void 0 : localConfig.config) === null || _c === void 0 ? void 0 : _c.switch_config_checksum) === null || _d === void 0 ? void 0 : _d['switch_config'];
                        localSampledConfig = (_g = (_f = (_e = localConfig === null || localConfig === void 0 ? void 0 : localConfig.config) === null || _e === void 0 ? void 0 : _e.switch_config_extra) === null || _f === void 0 ? void 0 : _f.switch_config) === null || _g === void 0 ? void 0 : _g.is_sampled;
                        shouldReCalcSample = localConfigCheckSum === GET_SAMPLED_RESULT_FROM_CLIENT_VALUE && this.defaultSample !== (localConfig === null || localConfig === void 0 ? void 0 : localConfig.default_sample);
                        return [4 /*yield*/, this.network.fetchRemoteConfigs({
                                tags: ['web-performance'],
                                view: 'ALL',
                                user_id: this.configs.user_id,
                                sdk_name: manifest_json_1.default.name,
                                sdk_version: manifest_json_1.default.version,
                                os_name: (_h = this.reporter) === null || _h === void 0 ? void 0 : _h.userAgent.device.os_name,
                                os_version: (_j = this.reporter) === null || _j === void 0 ? void 0 : _j.userAgent.device.os_version,
                                device_name: (_k = this.reporter) === null || _k === void 0 ? void 0 : _k.userAgent.device.device_name,
                                device_id: (_l = this.reporter) === null || _l === void 0 ? void 0 : _l.fingerprint,
                                switch_config_labels: {
                                    app_version: this.configs.app_version
                                },
                                sdk_spec_checksum: localConfig === null || localConfig === void 0 ? void 0 : localConfig.sdk_spec_checksum,
                                switch_config_keys: [
                                    {
                                        key: 'switch_config',
                                        checksum: shouldReCalcSample ? '' : localConfigCheckSum,
                                        sample_sub_key: 'app_sample',
                                        default_sample_rate: this.defaultSample,
                                        is_sampled: localSampledConfig
                                    }
                                ],
                                algorithm_version: 'v1'
                            })];
                    case 4:
                        configs = _q.sent();
                        if ((configs === null || configs === void 0 ? void 0 : configs.time_offset) && this.reporter) {
                            this.reporter.timeOffset = configs.time_offset;
                        }
                        if (configs === null || configs === void 0 ? void 0 : configs.config) {
                            useLocalConfig = localConfigCheckSum && ((_o = (_m = configs === null || configs === void 0 ? void 0 : configs.config) === null || _m === void 0 ? void 0 : _m.switch_config_checksum) === null || _o === void 0 ? void 0 : _o['switch_config']) === localConfigCheckSum;
                            if (useLocalConfig) {
                                // 检测配置版本并更新
                                configs.config.switch_config = (_p = localConfig.config) === null || _p === void 0 ? void 0 : _p.switch_config;
                            }
                            configs.default_sample = this.defaultSample;
                            configs.user_id = this.configs.user_id;
                            configs.last_update = +new Date();
                            configs.reported = false;
                            this.storage.setObject(this.localConfigStorageKey, configs);
                        }
                        log_1.Logger.log("[MDAP] Local configs updated. " + this.localConfigStorageKey);
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _q.sent();
                        this.resetLocalConfig();
                        log_1.Logger.log('[MDAP] Failed to update local configs');
                        log_1.Logger.error(error_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    MdapSdk.prototype.sendConfigMonitor = function (triggerStatus) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (triggerStatus === void 0) { triggerStatus = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var skipReport, config, enableTasks, combineConfigs, data, error_2;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        _l.trys.push([0, 4, , 5]);
                        skipReport = !this.enable || !triggerStatus && ((_a = this.localConfig) === null || _a === void 0 ? void 0 : _a.reported);
                        if (!((_b = this.reporter) === null || _b === void 0 ? void 0 : _b.commonData) || skipReport) {
                            return [2 /*return*/];
                        }
                        if (!!((_c = this.reporter) === null || _c === void 0 ? void 0 : _c.fingerprint)) return [3 /*break*/, 2];
                        return [4 /*yield*/, ((_d = this.reporter) === null || _d === void 0 ? void 0 : _d.initFingerprint())];
                    case 1:
                        _l.sent();
                        _l.label = 2;
                    case 2:
                        config = (_e = this.localConfig) === null || _e === void 0 ? void 0 : _e.config;
                        enableTasks = (_h = (_g = (_f = config === null || config === void 0 ? void 0 : config.switch_config) === null || _f === void 0 ? void 0 : _f.switch_config) === null || _g === void 0 ? void 0 : _g.enable_tasks) !== null && _h !== void 0 ? _h : 0;
                        combineConfigs = __assign(__assign({}, this.configMonitor), { status: triggerStatus, is_vip: (config === null || config === void 0 ? void 0 : config.vip_user) ? 1 : 0, invoke_tasks: this.configMonitor.install_tasks & enableTasks, enable_tasks: enableTasks, used_config: (_j = JSON.stringify(config)) !== null && _j !== void 0 ? _j : '', extra_info: JSON.stringify({
                                time_offset: this.reporter.timeOffset
                            }) });
                        data = __assign(__assign({}, (_k = this.reporter) === null || _k === void 0 ? void 0 : _k.commonData), { event_timestamp: this.reporter.serverNow(), tag: 'config-monitor', data: combineConfigs });
                        return [4 /*yield*/, this.network.sendConfigMonitor(data)];
                    case 3:
                        _l.sent();
                        /**
                         * set config reported
                         */
                        if (this.localConfig && !triggerStatus) {
                            this.localConfig = __assign(__assign({}, this.localConfig), { reported: true });
                            this.storage.setObject(this.localConfigStorageKey, this.localConfig);
                        }
                        log_1.Logger.log('[MDAP] Send config data successfully.', data);
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _l.sent();
                        log_1.Logger.log('[MDAP] Send config data failed.');
                        log_1.Logger.error(error_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /* use report plugin */
    MdapSdk.prototype.use = function (plugin) {
        var _a, _b, _c;
        if (!this.inited || !this.enable) {
            return;
        }
        var offsetByte = (_b = (_a = plugin.offsetByte) !== null && _a !== void 0 ? _a : constants_1.PluginOffsetByte[plugin.type]) !== null && _b !== void 0 ? _b : 0;
        var firstInstall = offsetByte && (this.configMonitor.install_tasks & offsetByte) == 0;
        if (firstInstall) {
            this.configMonitor.install_tasks += offsetByte;
        }
        if (this.remoteConfigMap[plugin.type]) {
            plugin.updateConfig(this.remoteConfigMap[plugin.type]);
        }
        (_c = this.reporter) === null || _c === void 0 ? void 0 : _c.register(plugin);
    };
    MdapSdk.prototype.remove = function (plugin) {
        var _a;
        (_a = this.reporter) === null || _a === void 0 ? void 0 : _a.unregister(plugin);
    };
    /* Add tag for each entry data. Usually for data search or filter */
    MdapSdk.prototype.addEntryTag = function (tag, value) {
        if (!tag) {
            log_1.Logger.warn('[MDAP] addTag - tag is required');
            return;
        }
        if (!this.reporter) {
            return;
        }
        if (!(0, validators_1.isValidTag)(tag, value)) {
            log_1.Logger.warn('[MDAP] addTag - invalid tag key or value');
            return;
        }
        this.reporter.tags[tag] = value.toString();
    };
    MdapSdk.prototype.removeEntryTag = function (tag) {
        if (!tag) {
            log_1.Logger.warn('[MDAP] removeTag - tag is required');
            return;
        }
        if (!this.reporter) {
            return;
        }
        if (Object.prototype.hasOwnProperty.call(this.reporter.tags, tag)) {
            delete this.reporter.tags[tag];
        }
    };
    return MdapSdk;
}());
exports.MdapSdk = MdapSdk;
